/* =============================================================================
   assets/bbx-drawer.js — Bloom-Bloom cart drawer (19/10/2026, τελικο σχεδιο ιδιοκτητη)
   -----------------------------------------------------------------------------
   Markup: snippets/cart-drawer.liquid (<cart-drawer class="bbx">). Δουλευει ΜΑΖΙ με:
   - assets/cart-items.js (theme): +/−, Αφαιρεση, ξαναγραψιμο των ζωνων μετα απο καθε αλλαγη
   - assets/bb-cart-cp.js: ΠΡΟΣΘΗΚΗ απο τη σελιδα προϊοντος (ζωνες) + χαρτης BOX NOW
   Εδω:
   1. καρτελες «Καλαθι / Προτασεις»
   2. μετρητες: «Καλαθι (n)» στον τιτλο και στις καρτελες (απο το data-bbx-meta της ζωνης)
   3. «Συχνα αγοραζονται μαζι..»: φορτωνει απο /?section_id=bbx-cart-recs οταν ανοιγει το συρταρι
      και μετα απο καθε αλλαγη του καλαθιου (ιδιο αρωμα με οσα εχει ο πελατης)
   4. «Best seller»: κρυβει οσα ηδη εμφανιζονται πανω, δειχνει τα 4 πρωτα
   5. «+ Προσθηκη» απο τις προτασεις: /cart/add.js → πρασινο «✓ Προστεθηκε» → ανανεωση ζωνων
   6. σακουλα δωρου: «Προσθηκη» (/cart/add.js) και − / + (cart-items.updateQuantity του theme)
   7. «Μηνυμα στην παραγγελια»: ανοιγει / κλεινει το πεδιο (η αποθηκευση: <cart-note> του theme)
   ============================================================================= */
(function () {
  'use strict';
  if (window.__bbxDrawer) { return; }
  window.__bbxDrawer = true;

  var BAG = 54854761120071;
  var BS_MAX = 4;

  function D() { return document.getElementById('cart-drawer'); }
  function isOn(d) { return !!(d && d.classList.contains('bbx')); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function $(d, s) { return d.querySelector(s); }
  function $$(d, s) { return Array.prototype.slice.call(d.querySelectorAll(s)); }

  /* ---------- 1. καρτελες ---------- */
  function setTab(d, t) {
    if (d.getAttribute('data-bbx-tab') !== t) { d.setAttribute('data-bbx-tab', t); }
    $$(d, '[data-bbx-tab-btn]').forEach(function (b) {
      var on = String(b.getAttribute('data-bbx-tab-btn') === t);
      if (b.getAttribute('aria-selected') !== on) { b.setAttribute('aria-selected', on); }
    });
  }

  /* ---------- 2 + 4. μετρητες / Best seller ---------- */
  function setText(el, txt) { if (el && el.textContent !== txt) { el.textContent = txt; } }
  function sync(d) {
    if (!isOn(d)) { return; }
    setTab(d, d.getAttribute('data-bbx-tab') || 'cart'); /* αν ξαναγραφτηκε ολο το συρταρι, τα κουμπια ξαναπαιρνουν τη σωστη καρτελα */
    var meta = $(d, '[data-bbx-meta]');
    var n = meta ? (parseInt(meta.getAttribute('data-n'), 10) || 0) : 0;
    setText($(d, '[data-bbx-count]'), n > 0 ? '(' + n + ')' : '');
    setText($(d, '[data-bbx-tab-n="cart"]'), String(n));

    var same = {};
    $$(d, '.bbx-same .bbx-cc[data-handle]').forEach(function (e) { same[e.getAttribute('data-handle')] = true; });
    var shown = 0;
    var max = $(d, 'cart-items[data-empty="true"]') ? 5 : BS_MAX; /* αδειο καλαθι (προταση A): 5 Best seller */
    $$(d, '.bbx-bs .bbx-li[data-handle]').forEach(function (e) {
      var hide = !!same[e.getAttribute('data-handle')] || shown >= max;
      if (!hide) { shown++; }
      if (e.hidden !== hide) { e.hidden = hide; }
    });
    var bsh = $(d, '.bbx-bs .bbx-h');
    if (bsh && bsh.hidden !== (shown === 0)) { bsh.hidden = shown === 0; }
    setText($(d, '[data-bbx-tab-n="recs"]'), String($$(d, '.bbx-same .bbx-cc').length + shown));

    /* το cart-items.js βαζει flex/items-center στο σωμα οταν αδειαζει το καλαθι — το σωμα μας μενει block (CSS) */
  }

  /* ---------- 3. «Συχνα αγοραζονται μαζι..» ---------- */
  var opened = false;
  var reqId = 0;
  function cartSig(d) {
    return $$(d, 'cart-items .cart-item[data-variant-id]')
      .map(function (r) { return r.getAttribute('data-variant-id'); })
      .filter(function (v) { return String(v) !== String(BAG); })
      .sort().join(',');
  }
  function loadSame(d, force) {
    if (!isOn(d) || !opened) { return; }
    var box = $(d, '[data-bbx-same]');
    if (!box) { return; }
    var sig = cartSig(d);
    if (!force && box.getAttribute('data-sig') === sig) { return; }
    box.setAttribute('data-sig', sig);
    if (!sig) { box.innerHTML = ''; sync(d); return; }
    var my = ++reqId;
    fetch(root() + '?section_id=bbx-cart-recs', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (my !== reqId) { return; }
        var live = D();
        var b = live && $(live, '[data-bbx-same]');
        if (!b) { return; }
        var t = document.createElement('template');
        t.innerHTML = html || '';
        var inn = t.content.querySelector('.bbx-same-in');
        b.innerHTML = inn ? inn.innerHTML : '';
        b.setAttribute('data-sig', sig);
        sync(live);
      })
      .catch(function () { /* οι προτασεις ειναι προαιρετικες */ });
  }

  /* ---------- ανανεωση ζωνων μετα απο προσθηκη ---------- */
  function refresh(d) {
    var ci = $(d, 'cart-items');
    if (ci && ci.dataset.empty === 'false' && ci.fetchRequestOpts && typeof ci.refresh === 'function') {
      return Promise.resolve(ci.refresh());
    }
    if (typeof d.refresh === 'function') { return Promise.resolve(d.refresh(true)); }
    location.reload();
    return Promise.resolve();
  }

  /* ---------- 5 + 6. προσθηκη (προτασεις, σακουλα) ---------- */
  function add(d, id, btn, flash) {
    if (!id || btn.disabled) { return; }
    btn.disabled = true;
    var card = btn.closest('.bbx-cc, .bbx-li');
    var label = btn.textContent;
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: r.ok, j: null }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error((res.j && (res.j.description || res.j.message)) || 'error'); }
        if (flash && card) {
          card.classList.add('is-added');
          btn.textContent = card.classList.contains('bbx-li') ? '✓ Μπήκε' : '✓ Προστέθηκε';
        }
        return new Promise(function (ok) { setTimeout(ok, flash ? 1100 : 0); });
      })
      .then(function () { return refresh(D()); })
      .catch(function () {
        btn.textContent = 'Μη διαθέσιμο';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      });
  }

  /* ---------- 7. μηνυμα ---------- */
  /* 20/10/2026 (audit): το μηνυμα ειναι μεσα στη ζωνη .cart-drawer__summary, που ξαναγραφεται σε καθε
     αλλαγη του καλαθιου. Το <cart-note> του theme σωζει 300 ms αφου σταματησει το γραψιμο, οποτε το νεο
     πεδιο μπορει να ερθει με παλιο κειμενο, και το κουτι κλεινει. Κραταμε εδω το τελευταιο κειμενο και
     αν ηταν ανοιχτο, και τα ξαναβαζουμε μετα απο καθε ξαναγραψιμο (keepNote). */
  var NOTE_ID = 'cart-note-cart-drawer-form';
  var noteVal = null;
  var noteOpen = false;
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === NOTE_ID) { noteVal = e.target.value; }
  }, true);
  function keepNote(d) {
    if (!isOn(d)) { return; }
    var box = $(d, '#bbx-note');
    if (!box) { return; }
    var ta = box.querySelector('textarea');
    var btn = $(d, '[data-bbx-note]');
    if (ta && noteVal !== null && ta.value !== noteVal) {
      ta.value = noteVal;
      ta.dispatchEvent(new Event('input', { bubbles: true })); /* το <cart-note> το ξανασωζει */
    }
    if (noteOpen && box.hidden) {
      box.hidden = false;
      if (btn) { btn.setAttribute('aria-expanded', 'true'); setText(btn, 'Κλείσιμο'); }
    } else if (!noteOpen && btn && noteVal !== null) {
      setText(btn, noteVal.trim() ? 'Επεξεργασία ✓' : 'Προσθήκη');
    }
  }
  function toggleNote(d, btn) {
    var box = $(d, '#bbx-note');
    if (!box) { return; }
    var open = box.hidden;
    noteOpen = open;
    box.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    var ta = box.querySelector('textarea');
    if (open) {
      btn.textContent = 'Κλείσιμο';
      if (ta) { try { ta.focus({ preventScroll: true }); ta.setSelectionRange(ta.value.length, ta.value.length); } catch (x) { ta.focus(); } }
      try { box.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (x) { /* noop */ }
    } else {
      btn.textContent = ta && ta.value.trim() ? 'Επεξεργασία ✓' : 'Προσθήκη';
    }
  }

  /* ---------- clicks (delegation: οι ζωνες ξαναγραφονται) ---------- */
  document.addEventListener('click', function (e) {
    var d = D();
    var t = e.target;
    if (!isOn(d) || !t || !t.closest || !d.contains(t)) { return; }
    var el = t.closest('[data-bbx-tab-btn]');
    if (el) { setTab(d, el.getAttribute('data-bbx-tab-btn')); var body = $(d, '.bbx-body'); if (body) { body.scrollTop = 0; } return; }
    el = t.closest('[data-bbx-note]');
    if (el) { e.preventDefault(); toggleNote(d, el); return; }
    el = t.closest('[data-bbx-bag]');
    if (el) {
      e.preventDefault();
      var ci = $(d, 'cart-items');
      if (ci && typeof ci.updateQuantity === 'function' && ci.fetchRequestOpts) {
        ci.updateQuantity(el.getAttribute('data-line'), Math.max(0, parseInt(el.getAttribute('data-bbx-bag'), 10) || 0));
      }
      return;
    }
    el = t.closest('[data-bbx-bag-add]');
    if (el) { e.preventDefault(); add(d, el.getAttribute('data-bbx-bag-add'), el, false); return; }
    el = t.closest('[data-bbx-add]');
    if (el) { e.preventDefault(); add(d, el.getAttribute('data-bbx-add'), el, true); }
  });

  /* ---------- αλλαγες στο συρταρι (ζωνες) → μετρητες + προτασεις ---------- */
  var tick = null;
  function soon() {
    clearTimeout(tick);
    tick = setTimeout(function () { var d = D(); sync(d); loadSame(d, false); }, 60);
  }
  var observed = null;
  function watch() {
    var d = D();
    if (!isOn(d) || observed === d || !('MutationObserver' in window)) { return; }
    observed = d;
    new MutationObserver(function () { keepNote(D()); soon(); }).observe(d, { childList: true, subtree: true });
  }

  document.addEventListener('on:cart-drawer:before-open', function () {
    opened = true;
    watch();
    var d = D();
    sync(d);
    loadSame(d, false);
  });

  function init() {
    var d = D();
    if (!isOn(d)) { return; }
    setTab(d, d.getAttribute('data-bbx-tab') || 'cart');
    sync(d);
    watch();
    if (d.getAttribute('open') !== null) { opened = true; loadSame(d, false); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', function () { observed = null; init(); });
})();
